import { DEFAULT_ANALYSIS_START_YEAR } from '@/features/analysis/_utils';
import { baseTextSearchCriteria } from '@/features/project/_models/filter-base-data';
import { DateRangeSchema, isPS } from '@/utils';
import {
  aggregationTargetTypeEnum,
  aggregationTypeEnum,
  analysisAxisEnum,
  analysisTargetEnum,
  sheetTypeEnum,
} from '@/utils/enum';
import { z } from 'zod';
import { AnalysisAndProjectsSharedSearchSchema } from './shared-search';

export const initialValueOfAnalysisSearchForm = (
  currentFiscalYear: number,
) => ({
  // NOTE: 実際の値はルート由来の useAnalysisSheetType() から AnalysisSearchAccordion で上書きされる。
  // ここはフォーム初期化時のフォールバックで、共通フィールドの useWatch('sheetType') が undefined にならないようにするためだけ。
  sheetType: sheetTypeEnum.enum.RS,
  analysisTarget: analysisTargetEnum.enum.expenditure,
  textSearchCriteria: baseTextSearchCriteria.options,
  fiscalYearRange:
    isPS() && currentFiscalYear === DEFAULT_ANALYSIS_START_YEAR
      ? [2024, 2024]
      : [currentFiscalYear - 1, currentFiscalYear],
  aggregationType: aggregationTypeEnum.enum.finalized,
  aggregationTargetType: aggregationTargetTypeEnum.enum.total,
  analysisAxis: analysisAxisEnum.enum.organization,
  // 効果発現経路（指標）検索の初期値
  indicatorKeyword: null,
  indicatorKeywordSearchOnlyTitleAndDescription: false,
  indicatorType: null,
  indicatorTerm: null,
  indicatorDataNatureType: null,
  hasOnlyQualitativeIndicator: false,
});

const SharedSearch = AnalysisAndProjectsSharedSearchSchema.shape;
// 定義の順番がtagの並び順に影響
export const AnalysisSearchSchema = z.object({
  analysisTarget: analysisTargetEnum,
  fiscalYearRange: DateRangeSchema.nullish(),
  sheetType: SharedSearch.sheetType,
  q: SharedSearch.q,
  isSearchTargetProjectName: SharedSearch.isSearchTargetProjectName,
  corporateNumber: SharedSearch.corporateNumber,
  categories: SharedSearch.categories,
  implementationMethods: SharedSearch.implementationMethods,
  accountingType: SharedSearch.accountingType,
  accountingTypeIds: SharedSearch.accountingTypeIds,
  projectNumbers: SharedSearch.projectNumbers,
  period: SharedSearch.period,
  // cascader項目
  nestedOrganizationIds: SharedSearch.nestedOrganizationIds,
  nestedPolicyIds: SharedSearch.nestedPolicyIds,
  nestedOtherResponsibleOrganizationIds:
    SharedSearch.nestedOtherResponsibleOrganizationIds,
  nestedExpenditureBudgetPurposeIds:
    SharedSearch.nestedExpenditureBudgetPurposeIds,
  aggregationType: aggregationTypeEnum,
  aggregationTargetType: aggregationTargetTypeEnum,
  analysisAxis: analysisAxisEnum.nullable(),
});

export type AnalysisSearchFormType = z.infer<typeof AnalysisSearchSchema>;

type AnalysisSearchKeysType = keyof typeof AnalysisSearchSchema.shape;
export const AnalysisSearchKeys = Object.keys(
  AnalysisSearchSchema.shape,
) as AnalysisSearchKeysType[];
